"use strict";

var _regeneratorRuntime = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var base_transaction_1 = require("./base_transaction");

var constants_1 = require("./constants");

var errors_1 = require("./errors");

var validation_1 = require("./utils/validation");

exports.dappAssetFormatSchema = {
  type: 'object',
  required: ['dapp'],
  properties: {
    dapp: {
      type: 'object',
      required: ['name', 'type', 'category'],
      properties: {
        icon: {
          type: 'string',
          format: 'uri',
          maxLength: 2000
        },
        category: {
          type: 'integer',
          minimum: 0,
          maximum: 8
        },
        type: {
          type: 'integer',
          minimum: 0,
          maximum: 1
        },
        link: {
          type: 'string',
          format: 'uri',
          minLength: 0,
          maxLength: 2000
        },
        tags: {
          type: 'string',
          format: 'noNullByte',
          maxLength: 160
        },
        description: {
          type: 'string',
          format: 'noNullByte',
          maxLength: 160
        },
        name: {
          type: 'string',
          format: 'noNullByte',
          minLength: 1,
          maxLength: 32
        }
      }
    }
  }
};

var DappTransaction = /*#__PURE__*/function (_base_transaction_1$B) {
  _inherits(DappTransaction, _base_transaction_1$B);

  var _super = _createSuper(DappTransaction);

  function DappTransaction(rawTransaction) {
    var _this;

    _classCallCheck(this, DappTransaction);

    _this = _super.call(this, rawTransaction);
    var tx = typeof rawTransaction === 'object' && rawTransaction !== null ? rawTransaction : {};
    _this.asset = tx.asset || {
      dapp: {}
    };
    _this.containsUniqueData = true;

    if (_this.asset && _this.asset.dapp && typeof _this.asset.dapp === 'object') {
      _this.asset.dapp.description = _this.asset.dapp.description || undefined;
      _this.asset.dapp.icon = _this.asset.dapp.icon || undefined;
      _this.asset.dapp.tags = _this.asset.dapp.tags || undefined;
    }

    return _this;
  }

  _createClass(DappTransaction, [{
    key: "assetToBytes",
    value: function assetToBytes() {
      var DAPP_TYPE_LENGTH = 4;
      var DAPP_CATEGORY_LENGTH = 4;
      var _this$asset$dapp = this.asset.dapp,
          name = _this$asset$dapp.name,
          description = _this$asset$dapp.description,
          tags = _this$asset$dapp.tags,
          link = _this$asset$dapp.link,
          icon = _this$asset$dapp.icon,
          type = _this$asset$dapp.type,
          category = _this$asset$dapp.category;
      var nameBuffer = Buffer.from(name, 'utf8');
      var linkBuffer = link ? Buffer.from(link, 'utf8') : Buffer.alloc(0);
      var typeBuffer = Buffer.alloc(DAPP_TYPE_LENGTH);
      typeBuffer.writeIntLE(type, 0, DAPP_TYPE_LENGTH);
      var categoryBuffer = Buffer.alloc(DAPP_CATEGORY_LENGTH);
      categoryBuffer.writeIntLE(category, 0, DAPP_CATEGORY_LENGTH);
      var descriptionBuffer = description ? Buffer.from(description, 'utf8') : Buffer.alloc(0);
      var tagsBuffer = tags ? Buffer.from(tags, 'utf8') : Buffer.alloc(0);
      var iconBuffer = icon ? Buffer.from(icon, 'utf8') : Buffer.alloc(0);
      return Buffer.concat([nameBuffer, descriptionBuffer, tagsBuffer, linkBuffer, iconBuffer, typeBuffer, categoryBuffer]);
    }
  }, {
    key: "prepare",
    value: function () {
      var _prepare = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(store) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return store.account.cache([{
                  address: this.senderId
                }]);

              case 2:
                _context.next = 4;
                return store.transaction.cache([{
                  dapp_name: this.asset.dapp.name
                }, {
                  dapp_link: this.asset.dapp.link
                }]);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function prepare(_x) {
        return _prepare.apply(this, arguments);
      }

      return prepare;
    }()
  }, {
    key: "verifyAgainstTransactions",
    value: function verifyAgainstTransactions(transactions) {
      var _this2 = this;

      var sameTypeTransactions = transactions.filter(function (tx) {
        return tx.type === _this2.type;
      });
      var errors = sameTypeTransactions.filter(function (tx) {
        return 'dapp' in tx.asset && tx.asset.dapp.name === _this2.asset.dapp.name;
      }).length > 0 ? [new errors_1.TransactionError('Dapp with the same name already exists.', this.id, '.asset.dapp.name', this.asset.dapp.name)] : [];

      if (sameTypeTransactions.filter(function (tx) {
        return 'dapp' in tx.asset && _this2.asset.dapp.link && _this2.asset.dapp.link === tx.asset.dapp.link;
      }).length > 0) {
        errors.push(new errors_1.TransactionError('Dapp with the same link already exists.', this.id, '.asset.dapp.link', this.asset.dapp.link));
      }

      return errors;
    }
  }, {
    key: "validateAsset",
    value: function validateAsset() {
      validation_1.validator.validate(exports.dappAssetFormatSchema, this.asset);
      var errors = errors_1.convertToAssetError(this.id, validation_1.validator.errors);

      if (!this.amount.eq(0)) {
        errors.push(new errors_1.TransactionError('Amount must be zero for dapp transaction', this.id, '.amount', this.amount.toString(), '0'));
      }

      if (this.recipientId) {
        errors.push(new errors_1.TransactionError("RecipientId is expected to be undefined", this.id, '.recipientId'));
      }

      var validLinkSuffix = ['.zip'];

      if (errors.length > 0) {
        return errors;
      }

      if (this.asset.dapp.link && !validation_1.stringEndsWith(this.asset.dapp.link, validLinkSuffix)) {
        errors.push(new errors_1.TransactionError("Dapp icon must have suffix ".concat(validLinkSuffix.toString()), this.id, '.asset.dapp.link', this.asset.dapp.link));
      }

      var validIconSuffix = ['.png', '.jpeg', '.jpg'];

      if (this.asset.dapp.icon && !validation_1.stringEndsWith(this.asset.dapp.icon, validIconSuffix)) {
        errors.push(new errors_1.TransactionError("Dapp icon must have suffix of one of ".concat(validIconSuffix.toString()), this.id, '.asset.dapp.icon', this.asset.dapp.icon));
      }

      if (this.asset.dapp.tags) {
        var tags = this.asset.dapp.tags.split(',').map(function (tag) {
          return tag.trim();
        }).sort();

        if (tags.length !== new Set(tags).size) {
          errors.push(new errors_1.TransactionError("Dapp tags must have unique set", this.id, '.asset.dapp.tags', this.asset.dapp.tags));
        }
      }

      return errors;
    }
  }, {
    key: "applyAsset",
    value: function applyAsset(store) {
      var _this3 = this;

      var errors = [];
      var nameExists = store.transaction.find(function (transaction) {
        return transaction.type === DappTransaction.TYPE && transaction.id !== _this3.id && transaction.asset.dapp && transaction.asset.dapp.name === _this3.asset.dapp.name;
      });

      if (nameExists) {
        errors.push(new errors_1.TransactionError("Application name already exists: ".concat(this.asset.dapp.name), this.id, this.asset.dapp.name));
      }

      var linkExists = store.transaction.find(function (transaction) {
        return transaction.type === DappTransaction.TYPE && transaction.id !== _this3.id && transaction.asset.dapp && transaction.asset.dapp.link === _this3.asset.dapp.link;
      });

      if (linkExists) {
        errors.push(new errors_1.TransactionError("Application link already exists: ".concat(this.asset.dapp.link), this.id, this.asset.dapp.link));
      }

      return errors;
    }
  }, {
    key: "undoAsset",
    value: function undoAsset(_) {
      return [];
    }
  }, {
    key: "assetFromSync",
    value: function assetFromSync(raw) {
      if (!raw.dapp_name) {
        return undefined;
      }

      var dapp = {
        name: raw.dapp_name,
        description: raw.dapp_description,
        tags: raw.dapp_tags,
        type: raw.dapp_type,
        link: raw.dapp_link,
        category: raw.dapp_category,
        icon: raw.dapp_icon
      };
      return {
        dapp: dapp
      };
    }
  }]);

  return DappTransaction;
}(base_transaction_1.BaseTransaction);

DappTransaction.TYPE = 5;
DappTransaction.FEE = constants_1.DAPP_FEE.toString();
exports.DappTransaction = DappTransaction;